"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrandUsersEndpoint = void 0;
const brand_constants_1 = require("root/src/shared/brand/brand.constants");
const auth_1 = require("root/src/shared/constants/auth");
const authApiClient_types_1 = require("root/src/server/util/awsClients/authApiClient.types");
const lenses_1 = require("root/src/shared/descriptions/endpoints/lenses");
const brand_types_1 = require("root/src/shared/brand/brand.types");
exports.getBrandUsersEndpoint = {
    [brand_constants_1.brandEndpointIds.GET_BRAND_USERS]: {
        authentication: auth_1.authenticationTypes.authenticated,
        authenticationRole: [authApiClient_types_1.AuthGroup.Brand, authApiClient_types_1.AuthGroup.BrandAdmin, authApiClient_types_1.AuthGroup.BrandUser],
        payloadSchema: {
            type: 'object',
            properties: {
                filter: {
                    type: 'string',
                    enum: Object.values(brand_types_1.GetBrandUsersFilter),
                },
            },
        },
        endpointType: lenses_1.otherEndpointType,
    },
};
